import { Container, Row, Col, Button, Modal, Table, Form, InputGroup } from 'react-bootstrap'
import Loading from './common/loading';
import { useEffect, useState } from 'react'
import useApi from './../utilities/useApi';
import arrayUtilities from '../utilities/arrayUtilities';
import stringUtilities from '../utilities/stringUtilities'
import roleUtilities from '../utilities/roleUtilities'
import { Link, useNavigate } from 'react-router-dom'
import OrganisationSelector from './common/organisationSelector'
import FilterBar from './common/filterBar'
import CopyProjectModal from './_copyProjectModal';

export default function Projects(props) {
    const navigate = useNavigate();
    const { api } = useApi();
    const [isLoading, setIsLoading] = useState(true);
    const [filter, setFilter] = useState("");
    const [projects, setProjects] = useState(null);
    const [filteredProjects, setFilteredProjects] = useState(null);
    const [showCopyModal, setShowCopyModal] = useState(false);
    const [modalProject, setModalProject] = useState(null);
    const [includeDeleted, setIncludeDeleted] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const canManageProjects = roleUtilities.hasOrgAdminCapability(props.user)
    const getProjects = function (id, includeDeleted) {

        setIsLoading(true);
        if (!stringUtilities.isNullOrEmpty(id)) {
            api.getProjects(id, (data) => {
                setProjects(data);
                setIsLoading(false);
            }, () => {
                setProjects(null);
                setIsLoading(false);
            }, includeDeleted);
        }

    };

    useEffect(() => {
        setFilteredProjects(arrayUtilities.isNullOrEmpty(projects) ? [] : projects.filter((project) => {
            return stringUtilities.isNullOrEmpty(filter) || project.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 || project.id.toLowerCase().indexOf(filter.toLowerCase()) > -1;
        }));
    }, [filter, projects]);

    useEffect(() => {
        getProjects(props.organisationId, includeDeleted);
    }, [props.organisationId, includeDeleted]);

    const deleteProject = () => {
        api.deleteProject(
            props.organisationId,
            modalProject.id,
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getProjects(props.organisationId, includeDeleted);
                }
                setModalProject(null);
            },
            error => {
                console.log(error);
                setModalProject(null);
            }
        )
    }

    const onCopyProject = (newName) => {
        api.copyProject(
            props.organisationId,
            modalProject.id,
            newName,
            () => {
                getProjects(props.organisationId, includeDeleted);
                setShowCopyModal(false);
                setModalProject(null);
            },
            () => { }
        )
    }

    const unDeleteProject = () => {
        api.unDeleteProject(
            props.organisationId, modalProject.id, false,
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getProjects(props.organisationId, includeDeleted);
                }
                setModalProject(null);
            },
            error => {
                console.log(error);
                setModalProject(null);
            }
        )
    }

    return <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
        <Row>
            <Col className='mb-5'>
                <div className='d-flex justify-content-between my-5'>
                    <h1 className="h2 m-0">Projects</h1>

                    <div className='d-flex justify-content-end align-items-center'>
                        {
                            canManageProjects &&
                            <Form.Group className='d-flex align-items-center flex-shrink-0 me-4'>
                                <Form.Label className='text-body fs-sm me-2 mb-0 pe-1 text-nowrap'>
                                    Include deleted
                                </Form.Label>
                                <InputGroup size="sm">
                                    <Form.Check type='switch' id="include-deleted" className="me-2 pt-2" checked={includeDeleted} onChange={(e) => setIncludeDeleted(e.target.checked)} />
                                </InputGroup>
                            </Form.Group>
                        }

                        <FilterBar value={filter} onChange={setFilter} className="me-4" />

                        <OrganisationSelector value={props.organisationId ?? props.organisationalUnits[0].id} organisations={props.organisationalUnits} onChange={id => {
                            props.changeOrgId(id);
                            navigate(`/${id}/projects`)
                        }} />

                        {
                            canManageProjects &&
                            <Button onClick={() => navigate(`/${props.organisationId}/projects/add`)} size='sm' className='ms-2'>
                                <span className='d-flex align-items-center'><i className='fi-plus me-2'></i>
                                    Add Project</span>
                            </Button>
                        }
                    </div>
                </div>

                {
                    isLoading
                        ? <Loading />
                        : <Table responsive hover className='projects-table'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>
                                {!arrayUtilities.isNullOrEmpty(filteredProjects) && filteredProjects.map((project, index) => {
                                    const disabledBtn = project.isDeleted ? "disabled" : "";
                                    return <tr index={index} key={`project-${project.id}`}>
                                        <td className="align-middle w-100">
                                            <span className={project.isDeleted ? "text-muted" : ""}>{project.name}</span>
                                        </td>
                                        <td className="text-end w-100">
                                            <div className='d-flex w-100 justify-content-end'>
                                                {
                                                    !project.isDeleted &&
                                                    <div className='d-flex'>
                                                        {
                                                            canManageProjects &&
                                                            <>
                                                                <Link to={`/${props.organisationId}/projects/${project.id}/jobs`} className={`me-2 btn btn-light-primary shadow-sm btn-sm ${disabledBtn}`}>
                                                                    <span className='d-flex align-items-center'><i className='fi-briefcase me-2'></i> Jobs</span>
                                                                </Link>

                                                                    <Link to={`/${props.organisationId}/projects/${project.id}/workflows`} className={`me-2 btn btn-light-primary shadow-sm btn-sm ${disabledBtn}`}>
                                                                        <span className='d-flex align-items-center'><i className='fi-route me-2'></i> Workflows</span>
                                                                    </Link>
                                                                </>
                                                            }

                                                            <Link to={`/${props.organisationId}/projects/${project.id}/kml-files`} className={`me-2 btn btn-light-primary shadow-sm btn-sm ${disabledBtn}`}>
                                                                <span className='d-flex align-items-center'><i className='fi-code me-2'></i> KML Files</span>
                                                            </Link>

                                                        {
                                                            canManageProjects &&
                                                            <Link to={`/${props.organisationId}/projects/${project.id}/surfaces`} className={`me-2 btn btn-light-primary shadow-sm btn-sm ${disabledBtn}`}>
                                                                <span className='d-flex align-items-center'><i className="fi-play me-2 rotate-negative-90"></i> Surfaces</span>
                                                            </Link>
                                                        }

                                                            <Link to={`/${props.organisationId}/projects/${project.id}/map`} className={`me-2 btn btn-outline-primary shadow-sm btn-sm ${disabledBtn}`}>
                                                                <span className='d-flex align-items-center'><i className='fi-map-pin me-2'></i> Map</span>
                                                            </Link>

                                                        {
                                                            canManageProjects &&
                                                            <>
                                                                <Link to={`/${props.organisationId}/projects/${project.id}/import-data`} className="me-2 btn btn-light-primary shadow-sm btn-sm">
                                                                    <span className='d-flex align-items-center'><i className='fi-cloud-upload me-2'></i> Import</span>
                                                                </Link>

                                                                    <Button variant='secondary' size="sm" className={`me-2 btn btn-light-primary shadow-sm btn-sm ${disabledBtn}`} onClick={() => { setModalProject(project); setShowCopyModal(true); }}>
                                                                        <span className='d-flex align-items-center'><i className='fi-folders me-2'></i> Copy</span>
                                                                    </Button>

                                                                    <Link to={`/${props.organisationId}/projects/${project.id}`} variant='secondary' size="sm" className={`me-2 btn btn-light-primary shadow-sm btn-sm ${disabledBtn}`}>
                                                                        <span className='d-flex align-items-center'><i className='fi-edit me-2'></i> Edit</span>
                                                                    </Link>
                                                                    {
                                                                        project.isDeleted
                                                                            ? <Button className='shadow-sm' size="sm" variant="light" onClick={() => setModalProject(project)}>
                                                                                <span className='d-flex align-items-center'><i className='fi-rotate-left me-2'></i>Un-delete</span>
                                                                            </Button>
                                                                            : <Button className='' variant='outline-danger' size="sm" onClick={() => setModalProject(project)}>
                                                                                <span className='d-flex align-items-center'><i className='fi-trash me-2'></i> Delete</span>
                                                                            </Button>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                }
            </Col>
        </Row>

        {
            modalProject &&
            <Modal show onHide={() => setModalProject(null)} centered>
                <Modal.Header>
                    <Modal.Title>{modalProject.isDeleted ? <>Un-delete</> : <>Delete</>} project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to {modalProject.isDeleted ? <>un-delete</> : <>delete</>} the project "{modalProject.name}"?
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={() => setModalProject(null)}>Cancel</Button>
                    <Button size="sm" variant="primary" onClick={modalProject.isDeleted ? unDeleteProject : deleteProject}>Confirm</Button>
                </Modal.Footer>
            </Modal>
        }

        {
            !stringUtilities.isNullOrEmpty(errorMessage) &&
            <Modal show onHide={() => setErrorMessage(null)} centered>
                <Modal.Header><Modal.Title>Error</Modal.Title></Modal.Header>
                <Modal.Body>{errorMessage}</Modal.Body>
                <Modal.Footer><Button size="sm" variant='secondary' onClick={() => setErrorMessage(null)}>Close</Button></Modal.Footer>
            </Modal>
        }

        {
            showCopyModal && modalProject &&
            <CopyProjectModal onCopy={newName => onCopyProject(newName)} name={modalProject.name} onCancel={() => {
                setModalProject(null);
                setShowCopyModal(false);
            }} />
        }
    </Container>;
}